import { Link } from "wouter";

export default function NotFound() {
  return (
    <div data-testid="page-not-found" className="bg-spa-cream min-h-[80vh] flex items-center">
      <div className="container-spa py-24 text-center">
        <p className="overline mb-5">404</p>
        <h1 className="font-serif text-5xl sm:text-6xl text-spa-dark leading-tight mb-5">Page not found.</h1>
        <p className="text-spa-gray mb-8">The page you&apos;re looking for has wandered off.</p>
        <Link href="/" data-testid="notfound-home-link">
          <button className="btn-primary">Return home</button>
        </Link>
      </div>
    </div>
  );
}
